import React, { Component } from 'react';
import { Link } from 'react-router-dom';

class HeaderLogo extends Component {
	constructor(props){
	    super(props);
	}

	render() {
    return (
      <div className="logo">
        <Link to="/"><img src="/assets/images/logo.svg" alt="KKBits" className="img-fluid" /></Link>
      </div>
    )
	}
}

export default HeaderLogo;